export default __webpack_public_path__ + "static/artistBox-yumi-the-witch-34eb63fd61cc481c61bdb017a3f0bc65.png";